import { render, staticRenderFns } from "./screen_facturacion.vue?vue&type=template&id=04d2aa8b"
import script from "./screen_facturacion.vue?vue&type=script&lang=js"
export * from "./screen_facturacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports